<div class="p-grid justify-center">
  <div *ngFor="let widget of customWidgets | async">
    <div [class]="'p-col widget-' + widget.size + ' widget-dynamic-height'">
      <wsd-extended-card
        [loading]="false"
        [title]="widget.title"
        [redirectTo]="['/organizations', organizationId, 'modify', 'widgets']">

        <ng-container>
          <div [innerHTML]="sanitizeHtml(widget.content)" class="custom-widget-content">
          </div>
        </ng-container>

      </wsd-extended-card>
    </div>
  </div>
</div>
